import React from 'react';
import './WQM.css';
import FMSimage from '../Assets/Picture1water.jpg'; // First image (full size)
import FMSimage2 from '../Assets/water1.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/water4.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/water3.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/water2.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">WATER QUALITY MANAGEMENT SOLUTION</h1>
                    <p className="FMS-description">

                    The Water Supply Management System (WSMS) from Vajra IoT is an advanced solution for real-time monitoring and management of water distribution networks. It optimizes water usage, detects leaks, and enhances operational efficiency, making it an essential tool for sustainable water supply management in both urban and rural areas.






</p>                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Fuel Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
    <li><strong>Real-Time Monitoring:</strong>  Monitor water flow, pressure, and usage in real-time for efficient management.</li>
    <li><strong>Leak Detection:</strong>  Automatically detect leaks and wastage in the water distribution network, minimizing losses.</li>
    <li><strong>Remote Control:</strong> Remotely control and manage pumps, valves, and other equipment to optimize water distribution.</li>
    <li><strong>Water Quality Monitoring:</strong> Ensure water quality by continuously tracking parameters like pH, turbidity, and chlorine levels.</li>
    <li><strong>Fuel Monitoring:</strong> TReceive alerts for abnormal conditions such as low pressure, high consumption, or system malfunctions.</li>
</ul>

                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
  <li><strong>Centralized Monitoring:</strong> A web-based control system manages water distribution, providing real-time monitoring of flow rates, pressure levels, and water usage.</li>
  <li><strong>Automated Control:</strong> Water pumps, valves, and other equipment are controlled remotely to optimize distribution and ensure efficient water flow.</li>
  <li><strong>Leak Detection & Alerts:</strong> The system detects leaks and wastage in the network and sends alerts for immediate action to prevent water loss.</li>
  <li><strong>Water Quality Monitoring:</strong> Sensors continuously track water quality parameters such as pH, turbidity, and chlorine levels, ensuring safe water supply.</li>
  <li><strong>Usage Analysis:</strong> The system collects data on water consumption and provides insights to optimize usage and reduce wastage.</li>
</ul>


                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Water Quality Management Solution</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
    <li><strong>Improved Water Distribution:</strong> Real-time monitoring ensures efficient water flow, timely deliveries, and optimized water supply management.</li>
    <li><strong>Enhanced Water Quality Control:</strong> The system provides continuous monitoring of water quality parameters, ensuring safe and clean water supply.</li>
    <li><strong>Cost Savings:</strong> By tracking water usage, detecting leaks, and optimizing distribution, the system helps reduce water wastage and operational costs.</li>
    <li><strong>Ease of Use:</strong> The user-friendly, web-based platform simplifies water supply management, reporting, and monitoring, accessible from anywhere.</li>
</ul>


                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our FMS */}
            {/* New Section: Industries Using Our FMS */}
<div className="FMS-bottom-heading">
    <h2 className="FMS-bottom-text">Industries Using Our System</h2>
</div>

<div className="FMS-content-container reverse-order-last">
    {/* Left side: Image for Industries */}
    <div className="FMS-image-container">
        <img src={FMSimage5} alt="Industries Using FMS" className="FMS-image smaller-size" />
    </div>

    {/* Right side: Text Content */}
    <div className="FMS-text">
        <p className="FMS-description">
        Our Water Supply Management System is trusted by various sectors to optimize water distribution, enhance water quality, and reduce operational costs. These industries rely on our solution for its precision, reliability, and cost-saving benefits:           
    <ul>
        <li>Municipal Water Supply</li>
        <li>Industrial Water Management</li>
        <li>Agriculture Irrigation Systems</li>
        <li>Residential Water Distribution</li>
        <li>Commercial Water Systems</li>
    </ul>
</p>
    </div>
</div>

        </div>
    );
};

export default FMS;
